import React from 'react';
import { motion } from 'framer-motion';
import './RACBenefits.css';

const RACBenefits = () => {
  console.log('[RACBenefits] Component rendered');
  
  const benefits = [
    'Tangible livestock asset with 1:1 animal mapping',
    'Monthly hire rent payout with transparent Active Lease Days basis',
    'Managed operations with daily logs/records and monthly statements',
    'Planned dry period handled professionally; monthly hire rent adjusts by proration',
    'Replacement process defined (within 30 working days, excluding Saturdays, Sundays, and declared government holidays, as per the hire-back agreement)',
    'Clear exit/buyback pathway after lock-in (as per the hire-back agreement)'
  ];
  
  return (
    <section className="rac-benefits">
      <div className="rac-benefits-container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-section-title"
        >
          Benefits
        </motion.h2>
        <div className="rac-gold-line"></div>
        
        <motion.ul
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="rac-benefits-list"
        >
          {benefits.map((benefit, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="rac-benefit-item"
            >
              <span className="rac-benefit-check">✓</span>
              <span>{benefit}</span>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default RACBenefits;


